import React from 'react';
import Icon from '@salesforce/design-system-react/components/icon';
import { colors, type, space, radius, elevation } from '../tokens';
import SparkLine from './SparkLine';

const trendColor = (delta) => {
  if (delta == null) return colors.textTertiary;
  if (delta > 0) return colors.success;
  if (delta < 0) return colors.error;
  return colors.textTertiary;
};

const KPITile = ({ tile }) => {
  const color = tile.color || colors.brand;
  return (
    <div
      style={{
        flex: 1,
        minWidth: 150,
        background: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: radius.md,
        padding: `${space[3]}px ${space[4]}px`,
        display: 'flex',
        flexDirection: 'column',
        gap: space[1],
        position: 'relative',
        transition: 'box-shadow 160ms, transform 160ms',
      }}
      onMouseEnter={e => { e.currentTarget.style.boxShadow = elevation.cardHover; }}
      onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ ...type.label, color: colors.textTertiary }}>{tile.label}</span>
        {tile.sparkline && (
          <SparkLine values={tile.sparkline} color={color} width={60} height={18} />
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: space[2] }}>
        <span style={{ ...type.kpi, color: colors.textPrimary }}>{tile.value}</span>
        {tile.unit && (
          <span style={{ ...type.kpiUnit, color: colors.textTertiary }}>{tile.unit}</span>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: space[2], minHeight: 18 }}>
        {tile.subValue && (
          <span style={{ ...type.small, color: colors.textTertiary }}>{tile.subValue}</span>
        )}
        {(tile.delta != null || tile.deltaLabel) && (
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 2,
            ...type.small,
            fontWeight: 600,
            color: trendColor(tile.delta),
          }}>
            {tile.delta != null && (
              <Icon
                category="utility"
                name={tile.delta > 0 ? 'arrowup' : tile.delta < 0 ? 'arrowdown' : 'dash'}
                size="xx-small"
                style={{ fill: trendColor(tile.delta) }}
              />
            )}
            {tile.deltaLabel || (tile.delta != null ? `${tile.delta > 0 ? '+' : ''}${tile.delta}%` : null)}
          </span>
        )}
      </div>
    </div>
  );
};

const KPIStrip = ({ tiles = [] }) => (
  <div style={{
    display: 'flex',
    gap: space[3],
    flexWrap: 'wrap',
    marginBottom: space[5],
  }}>
    {tiles.map((t, i) => <KPITile key={t.id || i} tile={t} />)}
  </div>
);

export default KPIStrip;
